import { render } from "./DownloadVcard.vue?vue&type=template&id=22ec8bde"
import script from "./DownloadVcard.vue?vue&type=script&lang=js"
export * from "./DownloadVcard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__